import React, { useEffect, useRef, useState } from 'react'
import { ContentGrid } from '../ContentGrid'
import SectionWithTag from '../../components/SectionWithTag'
import TestimonialPicture from './components/TestimonialPicture'
import FadeIn from '../../components/Animation/FadeIn'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import TestimonialText from './components/TestimonialText'
import { useIsMobile } from '../../utils/helpers'
import { SetPaddingProps } from '../../utils/PaddingContext'
import TestimonialNavigation from './components/TestimonialNavigation'
import './index.css'

interface TestimonialsDesktopProps extends SetPaddingProps {
  data: any[]
}

const TestimonialsDesktop = ({ setPadding, data }: TestimonialsDesktopProps) => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0)
    const [loaded, setLoaded] = useState(false)

    const titleRef = useRef<HTMLDivElement>(null)
    const descriptionRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const isMobile = useIsMobile()

    useEffect(() => {
        const calculatePadding = () => {
            requestAnimationFrame(() => {
                if (titleRef.current && descriptionRef.current && contentRef.current && !isMobile) {
                    const pad = {
                        paddingLeft:
              titleRef.current.getBoundingClientRect().left -
              contentRef.current.getBoundingClientRect().left,
                        paddingRight: descriptionRef.current.getBoundingClientRect().width * 0.15,
                    }
                    setPadding(pad)
                } else {
                    setPadding()
                }
            })
        }
        calculatePadding()
        window.addEventListener('resize', calculatePadding)
        return () => {
            window.removeEventListener('resize', calculatePadding)
        }
    }, [titleRef, descriptionRef, isMobile, contentRef, loaded, setPadding])

    return (
        <div className='border-t border-black/10 bg-white'>
            <ContentGrid className='3xl:max-w-screen-2xl mx-auto'>
                <div className='aspect-auto' ref={contentRef}>
                    <FadeIn>
                        <SectionWithTag
                            tag={{ id: 'page.partnerships.testimonials', className: 'hidden md:flex' }}
                            className='content-grid--tag-small content-grid--testimonial md:justify-center'
                        >
                            <SwitchTransition mode='out-in'>
                                <CSSTransition
                                    key={currentTestimonial}
                                    addEndListener={(node, done) => {
                                        node.addEventListener('transitionend', done, false)
                                    }}
                                    classNames='fade'
                                >
                                    <div className='xl:py-24 bg-white flex flex-col items-center justify-center'>
                                        <div>
                                            <TestimonialText {...data[currentTestimonial]} titleRef={titleRef} />
                                            <TestimonialNavigation
                                                count={data.length}
                                                currentTestimonial={currentTestimonial}
                                                setCurrentTestimonial={setCurrentTestimonial}
                                            />
                                        </div>
                                    </div>
                                </CSSTransition>
                            </SwitchTransition>
                        </SectionWithTag>
                    </FadeIn>
                </div>
                <div className='aspect-auto'>
                    <div className='h-full flex items-center justify-center p-[15%]' ref={descriptionRef}>
                        <div>
                            <TestimonialPicture
                                slug={data[currentTestimonial].picture}
                                className={data[currentTestimonial].pictureClasses}
                                onLoad={() => setLoaded(true)}
                            />
                        </div>
                    </div>
                </div>
            </ContentGrid>
        </div>
    )
}

export default TestimonialsDesktop
